import Sparkline from "components/charts/modern/SparklineChart";
import formatMoneyValueOnlyDigits from "components/utils/formatMoneyValueOnlyDigits";
import last from "lodash/fp/last";
import type { ITotalCompensationByYear } from "types/graphqlTypes";

interface AmericanIssuerTotalCompensationSummaryProps {
  totalCompensations: ITotalCompensationByYear[];
}

export default function AmericanIssuerTotalCompensationSummary({
  totalCompensations,
}: AmericanIssuerTotalCompensationSummaryProps) {
  const node = last(totalCompensations);
  if (!node) {
    return null;
  }

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-8">
      <div>
        <h1 className="m-0 text-xl font-bold tracking-wider text-slate-800">
          ${formatMoneyValueOnlyDigits(node.totalCompensation)}
        </h1>

        <span className="text-sm font-medium text-slate-500">Total (U.S. Dollar) • {node.fiscalYear}</span>
      </div>

      {totalCompensations.length >= 3 && (
        <Sparkline
          type="area"
          className="h-14 w-full min-w-0 sm:max-w-xs"
          accessibilityDescription="A chart representation of the values spent in compensations for officers"
          data={totalCompensations.map((node) => {
            return {
              y: node.totalCompensation,
            };
          })}
        />
      )}
    </div>
  );
}
